// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__1G1sr","footer":"ModalFilter_footer__2-2Ov"};